import styled, { css } from 'styled-components';

import { getColor, media } from 'styles/utils';
import InfoIcon from 'vectors/info.svg';

export const InfoButton = styled(InfoIcon)<InfoButtonProps>`
  cursor: pointer;
  width: 15px;
  height: 15px;
  align-self: center;
  margin: ${({ margin }) => margin || '0'};
  flex-shrink: 0;

  path {
    fill: ${({ variant }) => getColor(variant || ['blue', 'dark'])};
  };

  ${({ $scalable }) => $scalable && css`
    ${media.desktop`
      transform: scale(1.2);
    `}
  `}
`;

type InfoButtonProps = {
  variant?: 'blue' | 'white';
  margin?: string;
  $scalable?: boolean;
};
